import { useEffect, useState } from "react";

import { Tag, useGetAllTagsQuery } from "../redux/slices/tag-api";

export type useGetTagsType = {
  tags: Tag[];
  loading: boolean;
};

export enum TagSortValues {
  name = "name",
  noOfPlays = "noOfPlays",
  noOfPlayBooks = "noOfPlayBooks",
}

export type useGetTagsProps = {
  searchTerm: string;
  sort: { sortValue: TagSortValues; sortDirection: string };
};

export const useGetTags = ({ searchTerm, sort }: useGetTagsProps): useGetTagsType => {
  const [tags, setTags] = useState<Tag[]>([]);
  const { data: tagData, isLoading: loading } = useGetAllTagsQuery();

  useEffect(() => {
    if (tagData) {
      setTags(tagData);
    }
  }, [tagData]);

  useEffect(() => {
    if (tagData) {
      const filteredTagData = searchTerm
        ? tagData.filter((tag) => tag.name.toLowerCase().includes(searchTerm.toLowerCase()))
        : tagData;

      const sortedTagData = sort.sortValue
        ? [...filteredTagData].sort((a, b) => {
            if (sort.sortDirection === "asc") {
              return a[sort.sortValue] > b[sort.sortValue] ? 1 : -1;
            } else {
              return a[sort.sortValue] < b[sort.sortValue] ? 1 : -1;
            }
          })
        : filteredTagData;

      setTags(sortedTagData);
    }
  }, [tagData, searchTerm, sort]);

  return { tags, loading };
};
